import styled from "styled-components";

export const Boxcentral = styled.div`
display: flex;
width: 100%;
align-items: center;
justify-content: center;
margin-right: 7vw;
`